import React, { memo } from 'react';
import { useGlobalAddressContext } from '../../../AddressInfo';
import { addressReducerTypes } from '../../../Reducer';
import Select from '../../../../../../../../Elements/ids/InputElements/Select';
import { mapAddressFormatsToSelect } from '../../../../../../../../Helpers/AddressHelper';

const AddressFormatSelector = () => {
  const { addressDispatch, addressState } = useGlobalAddressContext();
  return (
    <Select
      options={mapAddressFormatsToSelect()}
      defaultValue={addressState.address?.format}
      onChange={e => {
        addressDispatch({
          type: addressReducerTypes.changeAddressFormat,
          format: e.target.value,
        });
      }}
    />
  );
};

export default memo(AddressFormatSelector);
